export const MAX_BULK_UPDATE = 15;
